module.exports = __webpack_public_path__ + "img/PKM-Case-Study-600px.ca7b6459.jpeg";